import { z } from 'zod';

import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { BaseQuestionWidgetSchema } from './QuestionBaseSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export enum ClozeQuestionType {
  Default = 'default',
  Table = 'table'
}

export enum ClozeOptionType {
  Input = 'Input',
  Select = 'Select'
}

const ClozeOptionSchema = z.object({
  id: z.string(),
  type: z.nativeEnum(ClozeOptionType)
});

const SelectPossibleOptionSchema = z.object({
  id: z.string(),
  value: z.string()
});

export const ClozeQuestionWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.ClozeQuestion).extend({
  answerFragment: ProseMirrorJSONSchema,
  answerPlaceholder: z.string(),
  clozeOptions: z.record(z.string(), ClozeOptionSchema),
  clozeQuestionType: z.nativeEnum(ClozeQuestionType),
  saveAnswers: z.boolean(),
  selectPossibleOptions: z.record(z.string(), z.array(SelectPossibleOptionSchema)),
  withRandomAnswers: z.record(z.string(), z.boolean()),
  // Table-specific fields (present when clozeQuestionType === 'table')
  caption: ProseMirrorJSONSchema.optional(),
  columnOrder: z.array(z.string()).optional(),
  columnWidths: z.record(z.string(), z.number()).optional(),
  contentById: z.record(z.string(), ProseMirrorJSONSchema).optional(),
  rowOrder: z.array(z.string()).optional()
});

export type ClozeQuestionWidgetStaticSchemaType = z.infer<typeof ClozeQuestionWidgetStaticSchema>;
